// @flow
import React, { Component } from 'react';
// Components
import { InstantSearch, Configure } from 'react-instantsearch-dom';
import UnconnectedSearchBar from '../components/UnconnectedSearchBar';
// Composers
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// Selectors
import { searchStateSelector } from '../selectors';
// Actions
import { updateSearch, createURL } from '../actions';
// Typesense
import { searchClient } from '../typesenseAdapter';
// Styles
import './SearchBar.css';
// Types
import type { Connector } from 'react-redux';
import type { ReduxState } from '../types';
import type { Dispatch } from '../../types';

/**
 * TYPE DEFINITIONS
 */
// TODO: Make this ESLint unecessary
/*eslint-disable */
type ReduxProps = {
  searchState: ReduxState,
  updateSearch: (searchState: ReduxState) => void,
};
/*eslint-enable */
type OwnProps = {};
type Props = {
  //prettier-ignore
  /* :: ...ReduxProps, */
  //prettier-ignore
  /* :: ...OwnProps */
};
type State = {
  currentQuery: string,
};

/**
 * COMPONENT DEFINITION
 */
class SearchBar extends Component {
  props: Props;
  state: State;

  get isSearchPage() {
    return this.props.location.pathname === '/busca';
  }

  render() {
    const onSubmitSearch = (query) => {
      this.props.updateSearch({
        ...this.props.searchState,
        query: query || '*',
        page: 1,
      });
    };

    return (
      <section className="search-bar-main" role="search">
        <InstantSearch
          key={this.props.location.key}
          searchClient={searchClient}
          indexName={process.env.REACT_APP_TYPESENSE_PRODUCT_INDEX || 'product_sales_production'}
        >
          <Configure hitsPerPage={5} />
          <UnconnectedSearchBar onSubmit={onSubmitSearch} />
        </InstantSearch>

        {this.isSearchPage && (
          <InstantSearch
            searchClient={searchClient}
            indexName={process.env.REACT_APP_TYPESENSE_PRODUCT_INDEX || 'product_sales_production'}
            searchState={this.props.searchState}
            onSearchStateChange={this.props.updateSearch.bind(this)}
            createURL={createURL}
          >
            <Configure hitsPerPage={20} />
          </InstantSearch>
        )}
      </section>
    );
  }
}

/**
 * CONNECTOR SETUP
 */
const mapStateToProps = (state, ownProps) => {
  return {
    searchState: searchStateSelector(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps) => {
  return {
    updateSearch: searchState => {
      dispatch(updateSearch(searchState));
    },
  };
};

const connector: Connector<OwnProps, Props> = connect(
  mapStateToProps,
  mapDispatchToProps,
);
export default withRouter(connector(SearchBar));
